import { comparisonData } from "@/mocks/articles";

export default function ComparisonSection() {
  return (
    <section className="relative overflow-hidden bg-background-50">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="flex flex-col lg:flex-row gap-0">
          <div className="w-full lg:w-[60%] py-10 md:py-14 pr-0 lg:pr-16">
            <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-12">
              Kakobuy vs<br />Konkurencja
            </h2>

            <div className="grid grid-cols-3 gap-0">
              {comparisonData.slice(0, 3).map((item, idx) => (
                <div
                  key={item.agent}
                  className={`${idx < 2 ? "border-r border-background-200/70" : ""} ${
                    idx === 0 ? "pr-6 md:pr-10" : idx === 2 ? "pl-6 md:pl-10" : "px-6 md:px-10"
                  }`}
                >
                  <p className="text-5xl md:text-6xl font-extrabold text-accent-500 leading-none mb-3">
                    {item.overall}
                  </p>
                  <p className="text-sm md:text-base text-foreground-600 leading-snug">
                    {item.agent} —<br />Cena i Jakość
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="w-full lg:w-[40%] relative min-h-[200px] lg:min-h-0">
            <div className="absolute inset-0 bg-gradient-to-br from-accent-50 via-accent-100/60 to-accent-200/40"></div>
            <div className="absolute inset-0 opacity-40">
              <div className="absolute top-6 right-12 w-28 h-28 rounded-full bg-accent-200/60"></div>
              <div className="absolute bottom-10 left-8 w-20 h-20 rounded-full bg-accent-300/50"></div>
              <div className="absolute top-1/2 left-1/2 w-36 h-16 rounded-full bg-accent-100/70"></div>
            </div>
          </div>
        </div>

        <div className="mt-10 overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="border-b border-background-200/70">
                <th className="py-4 pr-6 text-sm font-semibold text-foreground-500 whitespace-nowrap">Agent</th>
                <th className="py-4 px-4 text-sm font-semibold text-foreground-500 whitespace-nowrap">Cena</th>
                <th className="py-4 px-4 text-sm font-semibold text-foreground-500 whitespace-nowrap">Wysyłka</th>
                <th className="py-4 px-4 text-sm font-semibold text-foreground-500 whitespace-nowrap">Obsługa</th>
                <th className="py-4 pl-4 text-sm font-semibold text-foreground-500 whitespace-nowrap">Ocena</th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((item) => (
                <tr key={item.agent} className="border-b border-background-100 hover:bg-background-100/50 transition-colors">
                  <td className="py-4 pr-6">
                    <span className={`text-sm font-semibold whitespace-nowrap ${item.agent === "Kakobuy" ? "text-primary-600" : "text-foreground-800"}`}>
                      {item.agent}
                    </span>
                  </td>
                  <td className="py-4 px-4">
                    <div className="flex items-center gap-2">
                      <span className="text-sm text-foreground-700 font-medium">{item.price}</span>
                      <div className="w-16 h-1.5 bg-background-200 rounded-full overflow-hidden">
                        <div className="h-full bg-accent-500 rounded-full" style={{ width: `${(item.price / 10) * 100}%` }}></div>
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-4">
                    <div className="flex items-center gap-2">
                      <span className="text-sm text-foreground-700 font-medium">{item.shipping}</span>
                      <div className="w-16 h-1.5 bg-background-200 rounded-full overflow-hidden">
                        <div className="h-full bg-secondary-500 rounded-full" style={{ width: `${(item.shipping / 10) * 100}%` }}></div>
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-4">
                    <div className="flex items-center gap-2">
                      <span className="text-sm text-foreground-700 font-medium">{item.service}</span>
                      <div className="w-16 h-1.5 bg-background-200 rounded-full overflow-hidden">
                        <div className="h-full bg-primary-500 rounded-full" style={{ width: `${(item.service / 10) * 100}%` }}></div>
                      </div>
                    </div>
                  </td>
                  <td className="py-4 pl-4">
                    <span className="inline-flex items-center justify-center w-10 h-7 rounded-md bg-primary-100 text-primary-700 text-sm font-bold">
                      {item.overall}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}